import React from 'react';

import { SecurePickupContainers } from '../components/SecurePickupContainers/SecurePickupContainers';

const SecurePickupContainersOverview = () => {
  return <SecurePickupContainers />;
};

export default SecurePickupContainersOverview;
